<template>
  <main>
    <div class="add-note">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.addPeriodExam") }}</h3>
            </template>
            <template v-slot:right-element>
              <router-link :to="{name: 'periodexam_list'}" class="btn btn-outline-primary button" :disabled="loading">
                <i class="arrow left"></i>
                {{ $t("button.retour") }}
              </router-link>
            </template>
          </TopTemplate>
        </div>
      </div>

      <div v-if="is_created" class="alert alert-success" role="alert">{{ $t("common.succesExam") }}</div>

      <div v-for="(slot, index) in params" :key="index" class="row container-select bloc-crit container-filter content-crit">
        <h3 class="title-filter">{{ $t("notes.criteresAjout") }}</h3>
        <div class="col-sm-4 col-12 select-wrapper">
          <v-select
            v-model="slot.school_session_id"
            :options="slot.school_years"
            :searchable="false"
            label="name"
            class="form-control"
            placeholder="Année Scolaire"
            :class="{'is-invalid': v$.params.$errors[0]?.$response.$errors[index].school_session_id.length}"
            @update:modelValue="ListNotesFilter(index, 'yearSelected')"
            :reduce="(option) => option.id"
          >
            <template #no-options="{search, searching, loading}">{{ $t("info.noResult") }}</template>
          </v-select>
        </div>
        <div class="col-sm-4 col-12 select-wrapper">
          <v-select
            v-model="slot.spec_id"
            :options="specOptions"
            :searchable="false"
            label="name"
            class="form-control"
            :reduce="(option) => option.id"
            @update:modelValue="changeScolarity(index), ListNotesFilter(index, $event)"
            placeholder="Niveau"
          >
            <template #no-options="{search, searching, loading}">{{ $t("info.noResult") }}</template>
          </v-select>
        </div>
        <div class="col-sm-4 col-12 select-wrapper level-select">
          <v-select
            v-model="slot.level_id"
            :options="slot.school_levels"
            :searchable="false"
            multiple
            :class="{disabled: slot.disabled}"
            label="name"
            :reduce="(option) => option.id"
            placeholder="Niveau scolaire"
            @update:modelValue="ListNotesFilter(index, $event)"
          >
            <template #no-options="{search, searching, loading}">{{ $t("info.noResult") }}</template>
          </v-select>
        </div>
        <h3 class="title-filter title-period">{{ $t("notes.periodScoliare") }}</h3>
        <div class="col-sm-4 col-12 select-wrapper">
          <v-select
            v-model="slot.period_id"
            :options="slot.periods"
            :searchable="false"
            label="name"
            class="form-control"
            :class="{'is-invalid': v$.params.$errors[0]?.$response.$errors[index].period_id.length}"
            placeholder="Nom de la période"
            :reduce="(option) => option.id"
          >
            <template #no-options="{search, searching, loading}">{{ $t("info.noResult") }}</template>
          </v-select>
          <span v-if="v$.params.$errors[0]?.$response.$errors[index].period_id.length" class="invalid-feedback">{{
            v$.params.$errors[0]?.$response.$errors[index].period_id[0].$message
          }}</span>

          <span class="saisi-style">{{ $t("notes.saisi") }}</span>
        </div>
        <div class="col-sm-4">
          <span class="add-period">
            {{ $t("title.notExistPeriod") }}
            <span class="period-click" @click="showAddPeriod(index)">cliquer ici</span> pour la rajouter
          </span>
        </div>
        <div v-if="slot.isAddPeriod" class="container-filter conatiner-add-period">
          <div class="row content-crit">
            <div class="col-sm-4 col-12 select-wrapper">
              <input
                v-model="slot.periodName"
                class="form-control select-add-period"
                :class="{'is-invalid': v$.params.$errors[0]?.$response.$errors[index].periodName.length}"
                placeholder="Veuillez saisir le nom de la période"
              />
            </div>
            <button class="btn button btn-primary button" @click="addPeriod(index)">
              {{ $t("button.addPeriod") }}
            </button>
          </div>
        </div>
        <div>
          <div class="title-exam">
            <p>{{ $t("title.Exams") }}</p>
            <p>{{ $t("title.examsApplicable") }}</p>
          </div>
          <div v-if="slot.loadingExams" class="card text-center d-block pb-4 pt-4">
            <div class="spinner-border text-info" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-if="!slot.loadingExams" class="row items-wrapper">
            <div
              v-for="exam in slot.exam_types"
              :key="exam.id"
              class="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-xs-12 pointer"
              @click="(exam.is_checked = !exam.is_checked), checkValueCheckbox(index, exam.id)"
            >
              <div
                class="matiere-item form-control"
                :class="{'matiere-background': exam.is_checked, 'is-invalid': v$.params.$errors[0]?.$response.$errors[index].examItems.length}"
              >
                <span>{{ exam.name }}</span>
                <label class="container-checkbox">
                  <input v-model="slot.examItems" type="checkbox" :value="exam" />
                  <span class="checkmark" :class="exam.is_checked === true ? 'chekedchek' : ''"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 border-button">
        <button class="btn btn-outline-primary button btn-add-period" @click="addBlock()">
          <i class="icon-Add" />
          {{ $t("button.addRealPeriod") }}
        </button>
      </div>
      <div class="btn-wrapper">
        <button class="cancel-btn btn btn-outline-primary button btn-add-period" @click="resetExams()">
          {{ $t("button.cancel") }}
        </button>
        <button class="btn button btn-primary btn-save" @click="addExams()">
          {{ $t("button.savePeriod") }}
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import Button from "../../../components/buttons/Button";
import TopTemplate from "../../../components/toptemplate/TopTemplate.vue";
import vSelect from "vue-select";
import PeriodsService from "../../../services/periods.service";
import useValidate from "@vuelidate/core";
import {required, helpers, requiredIf} from "@vuelidate/validators";
// :class="{'is-invalid': v$.note.classe_id.$error && isError}"
export default {
  name: "addExamPeriod",
  components: {
    Button,
    TopTemplate,
    "v-select": vSelect,
  },
  data() {
    return {
      loading: true,
      v$: useValidate(),
      isSelected: false,
      isDraft: null,
      typeDevoire: "DEVOIR CONTRÔLE",
      isSubmitted: false,
      isError: false,
      classNameSelcted: null,
      periodNameSelcted: null,
      subjectNameSelcted: null,
      taskNameSelcted: null,
      periodsSelcted: null,
      courseSelcted: null,
      classes: [],
      periods: [],
      school_levels: [],
      school_years: [],
      exam_type: [],
      subjects: [{id: 1, name: "Arabe"}],
      tasks: [{id: 1, name: "Devoir de controle 1"}],
      courses: [],
      note: {
        course_id: null,
        classe_id: null,
        period_id: null,
        subject_id: null,
        task_id: null,
        status: null,
        exam_type: null,
        exam_id: null,
        periodsSelcted: null,
        courseSelcted: null,
        students: [],
      },
      params: [
        {
          school_session_id: null,
          spec_id: 1,
          level_id: [],
          period_id: null,
          periodName: null,
          examItems: [],
          isAddPeriod: false,
          periods: [],
          school_levels: [],
          school_years: [],
          disabled: false,
          exam_types: [],
          loadingExams: false,
          addPeriodVulidate: false,
        },
      ],
      is_created: false,
      specOptions: [
        {name: "Tous", id: 1},
        {name: "Personnalisé", id: 2},
      ],
      isAddPeriod: false,
      isYear: false,
      isCount: 0,
      addExamVulidate: false,
    };
  },
  validations() {
    return {
      params: {
        $each: helpers.forEach({
          period_id: {
            required: helpers.withMessage(
              this.$t("validation.required"),
              requiredIf((value, vm) => {
                return this.addExamVulidate == true;
              })
            ),
          },
          school_session_id: {
            required: requiredIf((value, vm) => {
              return vm.addPeriodVulidate == true;
            }),
          },
          periodName: {
            required: requiredIf((value, vm) => {
              return vm.addPeriodVulidate == true;
            }),
          },
          examItems: {
            $each: requiredIf((value, vm) => {
              return this.addExamVulidate == true;
            }),
          },
        }),
      },
    };
  },

  computed: {
    disabled() {
      return this.params.spec_id == 1;
    },
  },
  mounted() {
    this.ListNotesFilter(0);
    this.changeScolarity(0);
    this.ListingExamPeriod(0);
  },
  methods: {
    checkValueCheckbox(index, id) {
      if (this.params[index].examItems.includes(id)) {
        this.params[index].examItems = this.params[index].examItems.filter((el) => el !== id);
      } else {
        this.params[index].examItems.push(id);
      }
    },
    addBlock() {
      this.isCount += 1;
      this.params.push({
        school_session_id: null,
        spec_id: 1,
        level_id: [],
        period_id: null,
        periodName: null,
        examItems: [],
        isAddPeriod: false,
        periods: [],
        school_levels: [],
        school_years: [],
        disabled: false,
        loadingExams: false,
        addPeriodVulidate: false,
      });
      this.ListNotesFilter(this.isCount);
      this.changeScolarity(this.isCount);
    },
    changeScolarity(index) {
      this.params[index].disabled = this.params[index].spec_id === 1;
      this.params[index].level_id = [];
    },
    showAddPeriod(index) {
      this.params[index].isAddPeriod = !this.params[index].isAddPeriod;
    },
    ListNotesFilter(index, event) {
      this.params[index].loadingExams = true;
      this.isYear = event === "yearSelected";
      this.params[index].examItems = [];
      if (this.isYear) {
        this.params[index].level_id = [];
        this.params[index].period_id = null;
      }

      PeriodsService.ListScolarPeriodExamFilter({
        params: {
          school_session: this.params[index].school_session_id,
          type_id: this.params[index].level_id,
        },
      })
        .then((response) => {
          this.params[index].periods = response.data.periods;
          this.params[index].school_levels = response.data.school_levels;
          this.params[index].school_years = response.data.school_years;
          let exams = response.data.exam_types.map((el) => {
            return {...el, is_checked: false};
          });
          this.params[index].exam_types = exams;
          this.params[index].loadingExams = false;
        })
        .catch((error) => {
          console.error("error: ", error);
        });
    },
    ListingExamPeriod(index) {
      PeriodsService.ListingExamPeriod({
        params: {
          school_session: this.params[index].school_session_id,
          type_id: this.params[index].level_id,
        },
      })
        .then((response) => {
          console.log("response", response);
          // this.params[index].examItems
        })
        .catch((error) => {
          console.error("error: ", error);
        });
    },
    paramsAddPeriod(index) {
      return {
        period: this.params[index].periodName,
        school_session_id: this.params[index].school_session_id,
      };
    },
    paramsAddExam() {
      let class_types = this.params.map((el) => {
        return {
          level: el.level_id,
          period_id: el.period_id,
          exam_types: el.examItems,
        };
      });
      return {
        class_types,
      };
    },
    resetExams() {
      this.params = this.params.map((item, index) => ({
        ...item,
        school_session_id: null,
        spec_id: 1,
        level_id: [],
        period_id: null,
        examItems: [],
      }));

      Promise.all(
        this.params.map((value, index) => {
          this.changeScolarity(index);
          this.ListNotesFilter(index);
        })
      );
      this.$nextTick(() => {
        this.v$.$reset();
      });
    },
    addExams() {
      this.addExamVulidate = true;
      this.params = this.params.map((el) => {
        return {...el, addPeriodVulidate: false};
      });
      this.v$.$validate();
      this.$nextTick(() => {
        if (document.querySelector(".is-invalid")) {
          let domRect = document.querySelector(".is-invalid").getBoundingClientRect();
          window.scrollTo({
            left: domRect.left + document.documentElement.scrollLeft,
            top: domRect.top + document.documentElement.scrollTop - 90,
            behavior: "smooth",
          });
        }
      });
      if (!this.v$.$error) {
        PeriodsService.AddExam(this.paramsAddExam())
          .then((response) => {
            if (response.status === 201) {
              this.is_created = true;
              this.params = this.params.map((item, index) => ({
                ...item,
                school_session_id: null,
                spec_id: 1,
                level_id: [],
                period_id: null,
                examItems: [],
              }));
              this.params.forEach((value, index) => {
                this.changeScolarity(index);
                this.ListNotesFilter(index);
              });
              this.$nextTick(() => {
                this.v$.$reset();
              });
              this.scrollToTop();
              setTimeout(() => {
                this.$router.push({name: "periodexam_list"});
              }, 2000);
            }
          })
          .catch((error) => {
            console.error("error: ", error);
          });
      }
    },
    addPeriod(index) {
      this.params[index].addPeriodVulidate = true;
      this.addExamVulidate = false;
      this.v$.$validate();
      if (!this.v$.$error) {
        PeriodsService.AddPeriod(this.paramsAddPeriod(index))
          .then((response) => {
            this.ListNotesFilter(index);
            this.params[index].periodName = null;
            this.$nextTick(() => {
              this.v$.$reset();
            });
          })
          .catch((error) => {
            console.error("error: ", error);
          });
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.note-input {
  max-width: 60px;
  margin: 0 auto;
  text-align: center;
  color: #333333;
  font-size: 12px;
}

.btn-cancel {
  background: transparent;
}

.title-filter {
  font-size: 14px;
  font-weight: 700;
  color: #3d3d3d;
}

.title-filter {
  span {
    color: #377879;
  }
}

.title-filter-sub {
  font-size: 11px;
  font-weight: 500;
  color: #3d3d3d;
  font-style: italic;
  margin-left: 10px;
}

.btn-confirm-filter {
  margin-left: auto;
  margin-top: 15px;
  font-size: 14px;
  font-weight: 600;
  background-color: #377879;
  border-color: #377879;
}

.btn-confirm-filter:hover {
  color: #377879 !important;
  border-color: #377879;
}

.table__note.table > :not(caption) > * > * {
  border: none;
}

.table__note.table table td {
  border: none;
}

.table__note {
  padding: 4px;

  table {
    border-radius: unset;
    background: unset;
    padding: 23px;

    thead {
      tr {
        border-top: 3px solid #e0e7ed !important;
        border-bottom: 3px solid #e0e7ed !important;
        background: #f1fafa !important;

        th {
          color: #377879;
          font-size: 13px;
          font-weight: 700;
        }
      }
    }

    tbody {
      td {
        padding: 8px;
      }

      td.name-std {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
      }
    }
  }
}

.content-note {
  background: #fff;
  border-radius: 5px;
}

.title-tab-note {
  margin-bottom: 0;
  margin-top: 12px;
}

.btn-action {
  margin-top: 20px;
}

.cment-inp {
  input {
    padding-left: 20px;
    font-size: 12px;
    color: #333333;
  }

  input::placeholder {
    font-style: italic;
    color: #a098ae;
  }
}

.container-note {
  padding-bottom: 0;
  margin-bottom: 0;
  padding-top: 11px;
  padding-right: 0;
}

.btn-action-note {
  .button.btn-primary {
    background: #377879;
    border: 1px solid #377879;
  }

  .button.btn-primary:hover {
    background: #fff;

    color: #377879 !important;
  }

  .btn-cancel {
    color: #377879 !important;
    border: 1px solid #377879;
  }

  .btn-cancel:hover {
    background: #377879;
    color: #fff !important;
  }
}

.reset_note {
  color: #34b9bb;
  font-size: 14px;
  font-weight: 600;
}

.supparation {
  width: 100%;
  margin: 16px 0 19px 0;
  border-top: 1px solid #e0e7ed;
}

.title-period {
  margin-top: 22px;
}

.saisi-style {
  font-size: 11px;
  font-weight: 400;
  color: #3d3d3d;
  font-style: italic;
}

.btn-primary {
  height: fit-content;
}

.button-conf {
  margin-right: -35px;
}

.add-period {
  color: #3d3d3d;
  font-size: 12px;
  font-style: italic;
  font-weight: 600;
  margin-top: 11px;
  display: block;

  .period-click {
    color: #377879;
    cursor: pointer;
  }
}

.container-select {
  margin-bottom: 0;
}
.conatiner-add-period {
  background: #f2f6f6;
  padding: 25px;
  margin-top: 15px;
  border-radius: 4px;
}
.title-exam {
  margin: 15px 0;
  p {
    color: #3d3d3d;
    font-size: 10px;
    font-weight: 500px;
    margin-bottom: 0;
    &:nth-child(2n) {
      font-style: italic;
      font-weight: 400px;
    }
  }
}
.btn-add-period {
  color: #377879;
  border: 1px solid #377879;
  &:hover {
    background-color: #377879;
    color: #fff;
    i {
      color: #fff;
    }
  }
  i {
    color: #377879;
  }
}
.border-button {
  margin-top: 2px;
  border-top: 1px solid #e0e7ed;
  padding-top: 17px;
}
.btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  .cancel-btn {
    margin-right: 5px;
  }
}
.btn-save {
  background-color: #377879;
  border: 1px solid #377879;
  &:hover {
    border: 1px solid #377879;
    color: #377879 !important;
  }
}
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
}
.select-add-period {
  padding: 10px;
}
.bloc-crit {
  margin-top: 10px;
}
</style>
